// Reporta a New Relic SOLO el nombre del endpoint y el status HTTP.
// Nunca se envía el token, el objeto de error (puede traer config, headers y
// cuerpo del pedido con datos del huésped) ni el cuerpo de la respuesta.
export const getErrorStatus = error => {
  if (!error || typeof error !== "object") return null;
  if (error.response && typeof error.response.status === "number")
    return error.response.status;
  if (typeof error.status === "number") return error.status;
  return null;
};

export const reportErrorToNewRelic = (endpoint, error) => {
  if (typeof window.newrelic === "undefined") return;
  try {
    window.newrelic.noticeError(
      JSON.stringify({ endpoint, status: getErrorStatus(error) })
    );
  } catch (e) {
    // sin datos sensibles en el log
  }
};
